import { UncontrolledTooltip } from 'reactstrap';
import TextInput from '@/shared/ui/components/Inputs/textInput';
import useHintComments from './useHintComments';

export type HintCommentsProps = {
  className?: string;
  // some callers never pass these - pre-existing.
  disabled?: boolean;
  comments: string;
  updateComments: (name: string, value: string, isValid: boolean) => void;
  isAbortedStudy?: boolean;
};

const HintComments = ({
  className,
  disabled,
  comments,
  updateComments,
  isAbortedStudy,
}: HintCommentsProps) => {
  const { onChange } = useHintComments({ updateComments });

  return (
    <div id="hint-comments-tooltip" className="w-100 d-flex">
      <TextInput
        name="comments"
        type="textarea"
        ariaLabel="Comments"
        className={className}
        disabled={disabled || isAbortedStudy}
        value={comments}
        onChange={onChange}
      />

      {isAbortedStudy && (
        <UncontrolledTooltip
          className="custom-tooltip"
          target="hint-comments-tooltip"
          placement="bottom-end"
          delay={{ show: 0, hide: 0 }}
          hideArrow
        >
          The study has been aborted. You cannot perform any actions.
        </UncontrolledTooltip>
      )}
    </div>
  );
};

export default HintComments;
